module.exports = __webpack_public_path__ + "static/patent_batp-6be20d379d572cc3e2b4f44c12178665.png";